export default __webpack_public_path__ + "static/media/contact.b4b0b6a6.svg";